/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';
import { PasswordInput } from '@americanexpress/dls-react';
import { FxFormItem } from './FxFormItem';
import { getFieldStatus, getFieldErrorMessage } from '../../../utils/formUtils';

export const FxPasswordInputField = React.memo(
  ({
    id,
    label,
    isRequired,
    className,
    canExecuteFieldOnChange,
    showButton,
    input: {
 value, onChange, onBlur, onFocus,
},
    meta,
    handleOnChange = () => {},
    handleOnBlur = () => {},
    handleOnFocus = () => {},
    ...restProps
  }) => {
    const status = getFieldStatus(meta, value);
    const errorMessage = getFieldErrorMessage(meta, status);

    return (
      <FxFormItem
        id={id}
        className={className}
        label={label}
        isRequired={isRequired}
        status={status}
        errorMessage={errorMessage}
        {...restProps}
      >
        <PasswordInput
          id={id}
          value={value}
          status={status}
          describedBy={id}
          onChange={(e) => {
            if (canExecuteFieldOnChange) onChange(e);
            handleOnChange(e);
          }}
          onBlur={(e) => {
            onBlur(e);
            handleOnBlur(e);
          }}
          onFocus={(e) => {
            onFocus(e);
            handleOnFocus(e);
          }}
          {...restProps}
        />
      </FxFormItem>
    );
  }
);

FxPasswordInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  canExecuteFieldOnChange: PropTypes.bool,
  showButton: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({}).isRequired,
  handleOnChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  handleOnFocus: PropTypes.func,
};

FxPasswordInputField.defaultProps = {
  isRequired: false,
  className: null,
  canExecuteFieldOnChange: true,
  handleOnChange: () => {},
  handleOnBlur: () => {},
  handleOnFocus: () => {},
  showButton: true,
};
